// TODO: This duplicates TripOverviewPanels.ts consider some generic solution how to share this kind of functionalities between pages https://trello.com/c/4wELjdBw

import type { IngredientId } from '@libs/trip-planner-interfaces';

export enum HotelSelectionPanelType {
  None = 'none',
  HotelDetails = 'hotelDetails',
}

export interface HotelSelectionHotelDetailsPanel {
  type: HotelSelectionPanelType.HotelDetails;
  hotelCode: string;
  ingredientId: IngredientId;
}

export interface HotelSelectionNoPanel {
  type: HotelSelectionPanelType.None;
}

export type HotelSelectionPanel =
  | HotelSelectionHotelDetailsPanel
  | HotelSelectionNoPanel;

export const HOTEL_SELECTION_NO_PANEL: HotelSelectionNoPanel = {
  type: HotelSelectionPanelType.None,
};
